export const formatsIbanParIndicatifPays = {
    AD: /^AD\d{10}[A-Z0-9]{12}$/g,
    AE: /^AE\d{21}$/g,
    AL: /^AL\d{10}[A-Z0-9]{16}$/g,
    AT: /^AT\d{18}$/g,
    AZ: /^AZ\d{2}[A-Z]{4}[A-Z0-9]{20}$/g,
    BA: /^BA\d{18}$/g,
    BE: /^BE\d{14}$/g,
    BG: /^BG\d{2}[A-Z]{4}\d{6}[A-Z0-9]{8}$/g,
    BH: /^BH\d{2}[A-Z]{4}[A-Z0-9]{14}$/g,
    BI: /^BI\d{25}$/g,
    BR: /^BR\d{25}[A-Z][A-Z0-9]$/g,
    BY: /^BY\d{2}[A-Z0-9]{4}\d{4}[A-Z0-9]{16}$/g,
    CH: /^CH\d{7}[A-Z0-9]{12}$/g,
    CR: /^CR\d{20}$/g,
    CY: /^CY\d{10}[A-Z0-9]{16}$/g,
    CZ: /^CZ\d{22}$/g,
    DE: /^DE\d{20}$/g,
    DJ: /^DJ\d{25}$/g,
    DK: /^DK\d{16}$/g,
    DO: /^DO\d{2}[A-Z0-9]{4}\d{20}$/g,
    EE: /^EE\d{18}$/g,
    EG: /^EG\d{27}$/g,
    ES: /^ES\d{22}$/g,
    FI: /^FI\d{16}$/g,
    FK: /^FK\d{2}[A-Z]{2}\d{12}$/g,
    FO: /^FO\d{16}$/g,
    FR: /^FR\d{12}[A-Z0-9]{11}\d{2}$/g,
    GB: /^GB\d{2}[A-Z]{4}\d{14}$/g,
    GE: /^GE\d{2}[A-Z]{2}\d{16}$/g,
    GI: /^GI\d{2}[A-Z]{4}[A-Z0-9]{15}$/g,
    GL: /^GL\d{16}$/g,
    GR: /^GR\d{9}[A-Z0-9]{16}$/g,
    GT: /^GT\d{2}[A-Z0-9]{24}$/g,
    HN: /^HN\d{2}[A-Z]{4}\d{20}$/g,
    HR: /^HR\d{19}$/g,
    HU: /^HU\d{26}$/g,
    IE: /^IE\d{2}[A-Z]{4}\d{14}$/g,
    IL: /^IL\d{21}$/g,
    IQ: /^IQ\d{2}[A-Z]{4}\d{15}$/g,
    IS: /^IS\d{24}$/g,
    IT: /^IT\d{2}[A-Z]\d{10}[A-Z0-9]{12}$/g,
    JO: /^JO\d{2}[A-Z]{4}\d{4}[A-Z0-9]{18}$/g,
    KW: /^KW\d{2}[A-Z]{4}[A-Z0-9]{22}$/g,
    KZ: /^KZ\d{5}[A-Z0-9]{13}$/g,
    LB: /^LB\d{6}[A-Z0-9]{20}$/g,
    LC: /^LC\d{2}[A-Z]{4}[A-Z0-9]{24}$/g,
    LI: /^LI\d{7}[A-Z0-9]{12}$/g,
    LT: /^LT\d{18}$/g,
    LU: /^LU\d{5}[A-Z0-9]{13}$/g,
    LV: /^LV\d{2}[A-Z]{4}[A-Z0-9]{13}$/g,
    LY: /^LY\d{23}$/g,
    MC: /^MC\d{12}[A-Z0-9]{11}\d{2}$/g,
    MD: /^MD\d{2}[A-Z0-9]{20}$/g,
    ME: /^ME\d{20}$/g,
    MK: /^MK\d{5}[A-Z0-9]{10}\d{2}$/g,
    MN: /^MN\d{18}$/g,
    MR: /^MR\d{25}$/g,
    MT: /^MT\d{2}[A-Z]{4}\d{5}[A-Z0-9]{18}$/g,
    MU: /^MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$/g,
    NI: /^NI\d{2}[A-Z]{4}\d{20}$/g,
    NL: /^NL\d{2}[A-Z]{4}\d{10}$/g,
    NO: /^NO\d{13}$/g,
    OM: /^OM\d{5}[A-Z0-9]{16}$/g,
    PK: /^PK\d{2}[A-Z]{4}[A-Z0-9]{16}$/g,
    PL: /^PL\d{26}$/g,
    PS: /^PS\d{2}[A-Z]{4}[A-Z0-9]{21}$/g,
    PT: /^PT\d{23}$/g,
    QA: /^QA\d{2}[A-Z]{4}[A-Z0-9]{21}$/g,
    RO: /^RO\d{2}[A-Z]{4}[A-Z0-9]{16}$/g,
    RS: /^RS\d{20}$/g,
    RU: /^RU\d{16}[A-Z0-9]{15}$/g,
    SA: /^SA\d{4}[A-Z0-9]{18}$/g,
    SC: /^SC\d{2}[A-Z]{4}\d{20}[A-Z]{3}$/g,
    SD: /^SD\d{16}$/g,
    SE: /^SE\d{22}$/g,
    SI: /^SI\d{17}$/g,
    SK: /^SK\d{22}$/g,
    SM: /^SM\d{2}[A-Z]\d{10}[A-Z0-9]{12}$/g,
    SO: /^SO\d{21}$/g,
    ST: /^ST\d{23}$/g,
    SV: /^SV\d{2}[A-Z]{4}\d{20}$/g,
    TL: /^TL\d{21}$/g,
    TN: /^TN\d{22}$/g,
    TR: /^TR\d{8}[A-Z0-9]{16}$/g,
    UA: /^UA\d{8}[A-Z0-9]{19}$/g,
    VA: /^VA\d{20}$/g,
    VG: /^VG\d{2}[A-Z]{4}\d{16}$/g,
    XK: /^XK\d{18}$/g,
    YE: /^YE\d{2}[A-Z]{4}\d{4}[A-Z0-9]{18}$/g,
};

export function ibanEstValide(iban) {
    if (typeof iban !== 'string') {
        return false;
    }

    return formatIbanEstCorrect(formaterIban(iban));
}

// Conversion de l'IBAN en majuscules et suppression des caractères non alphanumériques
function formaterIban(iban) {
    return iban.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

function formatIbanEstCorrect(iban) {
    const indicatifPays = iban.slice(0, 2);
    const formatPays = formatsIbanParIndicatifPays[indicatifPays];
    if (formatPays === undefined) {
        return false;
    }

    return iban.match(formatPays) !== null;
}